
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 7a1 1 0 001 1h4.586l-6.162 6.162c-.21.21-.325.323-.414.4l-.01.008-.01-.009a8.173 8.173 0 01-.414-.4l-2.76-2.76a9.19 9.19 0 00-.512-.487 2.022 2.022 0 00-.686-.402 2 2 0 00-1.236 0c-.29.094-.512.254-.686.402-.16.135-.333.31-.512.488l-4.891 4.89a1 1 0 101.414 1.415l4.869-4.869c.21-.21.325-.323.414-.4L8 12.43l.01.009c.09.076.205.19.414.4l2.76 2.76c.179.178.352.352.511.487.175.148.397.308.687.402a2 2 0 001.236 0c.29-.094.512-.254.687-.402a9.18 9.18 0 00.51-.488L21 9.414V14a1 1 0 102 0V7a1 1 0 00-1-1h-7a1 1 0 00-1 1z","fill":"#fff"}})])
          )
        }
      }
    